import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import LivePlayer from 'v-component/smart/live-player.vue';
import LiveAction from 'v-component/smart/live-action.vue';
import LiveComment from 'v-component/smart/live-comment.vue';
import LiveFloat from 'v-component/smart/live-float.vue';
import {withDefaults} from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    info: { default: null }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LivePlayer, {
      live: true,
      url: __props.info.pull_url,
      poster: __props.info.cover_pic_url
    }, null, 8 /* PROPS */, ["url", "poster"]),
    _createVNode(LiveAction),
    _createVNode(LiveComment, {
      "host-uid": __props.info.tuid
    }, null, 8 /* PROPS */, ["host-uid"]),
    _createVNode(LiveFloat)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})